import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            关于我们
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            {aboutData.title}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100/70 border border-background-200/70 rounded-xl p-6 md:p-10">
            <div className="prose prose-sm max-w-none">
              {aboutData.description.split('\n\n').map((para, idx) => (
                <p key={idx} className="text-sm text-foreground-600 leading-relaxed mb-4 last:mb-0">
                  {para}
                </p>
              ))}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/70">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}